/* eslint-disable import/prefer-default-export */

import Bus from "bulb/dist/Bus";

/**
 * Redirects to the given URL.
 *
 * @param {String} url The URL.
 */
export function redirectTo(url) {
  setTimeout(() => {
    window.location = url;
  }, 0);
}

/**
 * The application event bus.
 *
 * This bus can be used to send events to any part of the application.
 */
export const eventBus = new Bus();
